import type { IProgressEvent } from "@ankaadia/ankaadia-shared";

/**
 * Abstract base for a progress-error notification service.
 *
 * Each application provides its own concrete implementation
 * (e.g. MessageService-based in the frontend).
 * The singleton is stored on this base class so that the shared
 * {@link reportProgress} operator can use it without knowing the concrete type.
 */
export abstract class ProgressErrorNotifierBase {
  static instance: ProgressErrorNotifierBase | null = null;

  abstract notifyError(event: IProgressEvent): void;
}
